import React from 'react';

import { EvLinkTypes, EvTableColumn, EvTableOptions } from '@evinced-private/ui-common';

import { MobileSdkVersionCellFormatter } from 'src/apps/mobile-sdk/components/mobile-sdk-version-cell-formatter/MobileSdkVersionCellFormatter';
import { IMobileSdkTestRow } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { DashboardTableLabel } from 'src/common/components/DashboardTableLabel/DashboardTableLabel';
import { EvLinkLocal } from 'src/common/components/ev-link-local/EvLinkLocal';
import { renderNumberCellFormatter } from 'src/common/components/ev-table/cell-formatters/numberCellFormatter';
import { MobilePlatformCellFormatter } from 'src/common/components/mobile-platform-cell-formatter/MobilePlatformCellFormatter';
import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

export const getMobileSdkTestsColumns = (): EvTableColumn[] => {
	return [
		{
			dataField: 'testName',
			text: 'Test Name',
			style: { width: '180px' },
			headerStyle: { width: '180px' },
			// sort: true, // TODO: Uncomment after backend support for sorting is ready
			formatter: (displayName: string, test: IMobileSdkTestRow) => {
				return (
					<EvLinkLocal
						className="mobile-sdk-test-name"
						id={test.runId}
						url={RoutesHelper.getMobileSdkTestPath(test.runId, SessionViews.OVERVIEW)}
						ariaLabel={`${displayName} Test`}
						linkText={displayName}
						type={EvLinkTypes.DARK}
					/>
				);
			}
		},
		{
			dataField: 'sdkType',
			text: 'SDK Type',
			style: { width: '155px' },
			headerStyle: { width: '155px' },
			sort: true,
			formatter: (sdkType: string, { productVersion }: IMobileSdkTestRow) => (
				<MobileSdkVersionCellFormatter label={sdkType} version={productVersion} />
			)
		},
		{
			dataField: 'platform',
			text: 'Platform',
			style: { width: '110px' },
			headerStyle: { width: '110px' },
			// sort: true, // TODO: Uncomment after backend support for sorting is ready
			formatter: (platforms: string[]) => <MobilePlatformCellFormatter platforms={platforms} />
		},
		{
			dataField: 'appName',
			text: 'App Name',
			style: { width: '150px' },
			headerStyle: { width: '150px' },
			// sort: true, // TODO: Uncomment after backend support for sorting is ready
			formatter: (appName: string, { appVersion }: IMobileSdkTestRow) => (
				<MobileSdkVersionCellFormatter label={appName} version={appVersion} />
			)
		},
		{
			dataField: 'totalScans',
			text: 'Scans',
			style: { width: '80px' },
			headerStyle: { width: '80px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'totalIssues',
			text: 'Issues',
			style: { width: '80px' },
			headerStyle: { width: '80px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'criticalIssues',
			text: 'Critical',
			style: { width: '80px' },
			headerStyle: { width: '80px' },
			sort: true,
			formatter: renderNumberCellFormatter
		},
		{
			dataField: 'testDate',
			text: 'Test Date',
			style: { width: '115px' },
			headerStyle: { width: '115px' },
			sort: true,
			formatter: (testDate: string) => (
				<p className="multi-line-value">{formatShortMonthDatetime(testDate)}</p>
			)
		},
		{
			dataField: 'labels',
			text: 'Labels',
			style: { width: '210px' },
			headerStyle: { width: '210px' },
			formatter: (labels: string[]) => <DashboardTableLabel labels={labels} />
		}
	];
};

const TABLE_KEY_FIELD = 'runId';
const TABLE_TITLE = 'Mobile SDK Tests';
const TABLE_CAPTION = 'Mobile SDK Tests table';
const DATA_TYPE = 'tests';

export const PLATFORM_TABLE_OPTIONS: EvTableOptions = {
	keyField: TABLE_KEY_FIELD,
	title: TABLE_TITLE,
	caption: TABLE_CAPTION,
	pagination: true,
	dataType: DATA_TYPE,
	remote: true
};
